import { PairingStatus } from '~/app/enums/PairingStatus';
import { TherapyJobStatus } from '~/app/enums/TherapyJobStatus';
import { TherapyJobV2 } from '~/app/models/TherapyJobV2';

export const unpairOnRunning = (tj: Partial<TherapyJobV2>) => {
  const unpaired = tj.pairingState === PairingStatus.UN_PAIRED || tj.pairingState === null;
  const running = tj.status === TherapyJobStatus.RUNNING;

  return running && unpaired;
};
